import { api } from '@/services/api'
import { extractTextFromPdf } from './pdfExtractor'

async function hashFile(file) {
  const buffer = await file.arrayBuffer()
  const hashBuf = await crypto.subtle.digest('SHA-256', buffer)
  const bytes = new Uint8Array(hashBuf)
  let hex = ''
  for (let i = 0; i < bytes.length; i++) {
    hex += bytes[i].toString(16).padStart(2, '0')
  }
  return hex
}

async function callApiExtract(text, fileHash) {
  const { data: resp } = await api.post('energy/extract', {
    text,
    file_hash: fileHash,
  })

  if (!resp || resp.status !== 'success') {
    throw new Error((resp && resp.message) || 'Erro ao extrair fatura via API.')
  }

  return resp.data
}

export async function extractBillFromPdf(file) {
  const fileHash = await hashFile(file)

  const text = await extractTextFromPdf(file)
  if (!text || text.trim().length < 50) {
    const err = new Error('Não foi possível extrair texto suficiente do PDF. Verifique se o arquivo é uma conta de energia legível (não pode ser escaneada como imagem sem OCR).')
    err.code = 'INSUFFICIENT_TEXT'
    throw err
  }

  const data = await callApiExtract(text, fileHash)

  return { data, fromCache: false, hash: fileHash }
}
